export default __webpack_public_path__ + "static/media/a1-4-11.b7022fef.jpg";